import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ANCHORS = [
    ["Product", "product"],
    ["Copilot", "copilot"],
    ["Migration", "migration"],
    ["Pricing", "pricing"],
];

export default function Nav() {
    const navigate = useNavigate();
    const location = useLocation();
    const onLanding = location.pathname === "/";

    const goToAnchor = (id) => (e) => {
        e.preventDefault();
        if (onLanding) {
            const el = id === "top" ? document.body : document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            // Land on homepage; Landing.jsx reads location.hash and scrolls into view.
            navigate(id === "top" ? "/" : `/#${id}`);
        }
    };

    return (
        <nav className="vy-nav" data-testid="landing-nav">
            <div className="vy-container vy-nav-inner">
                <a
                    href="/"
                    onClick={goToAnchor("top")}
                    style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none", color: "inherit" }}
                    data-testid="nav-logo"
                >
                    <img
                        src="/vyaahar-logo.png"
                        alt="Vyaahar"
                        style={{ height: 26, width: "auto", display: "block" }}
                    />
                </a>
                <div className="vy-nav-links">
                    {ANCHORS.map(([label, id]) => (
                        <a
                            key={id}
                            href={onLanding ? `#${id}` : `/#${id}`}
                            onClick={goToAnchor(id)}
                            data-testid={`nav-link-${id}`}
                        >
                            {label}
                        </a>
                    ))}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <button
                        type="button"
                        className="vy-btn vy-btn-sm vy-nav-signin"
                        style={{ padding: "8px 12px", borderRadius: 2 }}
                        onClick={() => navigate("/login")}
                        data-testid="nav-signin"
                    >
                        Sign in
                    </button>
                    <button
                        type="button"
                        className="vy-btn vy-btn-primary vy-btn-sm"
                        onClick={() => navigate("/signup")}
                        data-testid="nav-start-free"
                    >
                        Start free
                    </button>
                </div>
            </div>
        </nav>
    );
}
